import { makeStyles } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
// import Grid from "@material-ui/core/Grid";
import React from "react";

const useStyles = makeStyles(() => {
  return {
    progressLoader: {
      color: "#ffec37",
      position: 'absolute',
      top: '50%',
      left: '50%',
      // transform: 'translate(-50%, -50%)',
      zIndex: 1000, // Adjust as needed
    },
  };
});

export default () => {
  const classes = useStyles();
  return (
    // <Grid
    //   container={true}
    //   alignItems="center"
    //   justifyContent="center"
    //   style={{ height: "100%" }}
    // >

    <CircularProgress className={classes.progressLoader} size="3rem" />
    // </Grid>
  );
};



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.tsx